import { COUNTRY_CODES } from "@redotech/locale/country-codes";
import * as z from "zod";

const countryPhoneNumberMappingSchema = z.object({
  countryCode: z.enum(COUNTRY_CODES),
  phoneNumberId: z.string(),
});

export const getCountryPhoneNumbers = {
  name: "getCountryPhoneNumbers" as const,
  input: z.object({}),
  output: z.object({
    mappings: z.array(countryPhoneNumberMappingSchema),
    phoneNumbers: z.array(
      z.object({
        id: z.string(),
        number: z.string(),
        originatingCountry: z.string(),
      }),
    ),
  }),
};

/** Replaces the team's mappings with `mappings`. */
export const updateCountryPhoneNumbers = {
  name: "updateCountryPhoneNumbers" as const,
  input: z.object({ mappings: z.array(countryPhoneNumberMappingSchema) }),
  output: z.null(),
};
